import { renderTable } from "../../Components/Table/Table.js";
import { capitalize } from "../../Utilities/String.js";
import { singleton as singleton_2, tail, head, isEmpty, fold, map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { CreateFrozenMonthsDTO, convertFrozenMonthToViewModel } from "./Model.js";
import { addMonths, now, compare } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { strToOpt, DateOnlyExtensions_yyyy_MM_dd, DateTimeExtensions_toDate, DateOnlyExtensions_toDateTime, DateOnlyExtensions_getAbsoluteMonthDiff, Locale_get_FromSelectedLanguage, DateOnlyExtensions_fromDateTime } from "../../Utils.js";
import * as react from "react";
import { singleton, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { LoadState_zip3, loadEffect, LoadState_map, SaveStatus, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { uncurry, min } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { createFrozenMonths, loadAffectedFees as loadAffectedFees_1, loadFrozenMonthReason, loadIsFrozenMonthEnabled as loadIsFrozenMonthEnabled_1, loadFrozenMonths as loadFrozenMonths_1 } from "./Api.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { dotsLoading } from "../../ViewUtils.js";
import { info, error } from "../../Components/Message/Message.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption, CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox, DateOptions, DateOptions_get_getDefault, inputDate } from "../../Components/FormFields/FormFields.js";
import { MinimumDate, Locale, FormatDateBy, Id as Id_5, Value as Value_1, OnChange as OnChange_1 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { Browser_Types_Event__Event_get_Value, Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import "../../../src/Containers/FrozenMonths/View.scss";


function renderFrozenMonthsTable(getTranslation, locale, fees) {
    return renderTable(ofArray([getTranslation("Common.From"), getTranslation("Common.To"), capitalize(getTranslation("Common.Months")), getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonthsForm.Extend"), getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonthsForm.Reason")]), map((arg) => {
        const frozenMonthViewModel = convertFrozenMonthToViewModel(getTranslation, locale.ILocale, arg);
        return ofArray([frozenMonthViewModel.StartDate, frozenMonthViewModel.EndDate, frozenMonthViewModel.Months, frozenMonthViewModel.ImpactBinding, frozenMonthViewModel.Reason]);
    }, fees));
}

function renderImpactFee(getTranslation, impactFee, startDate, endDate) {
    let matchValue, children_2;
    if ((compare(impactFee.StartDate, startDate) <= 0) && ((matchValue = impactFee.EndDate, (matchValue == null) ? true : (compare(DateOnlyExtensions_fromDateTime(matchValue), endDate) <= 0)))) {
        const children_4 = [react.createElement("div", {
            className: "affect-fee__left",
        }, impactFee.Description), (children_2 = toList(delay(() => (impactFee.FeeImpact ? singleton(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateFrozenMonths.FeeImpact")) : singleton(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateFrozenMonths.FeeNotImpact"))))), react.createElement("div", {
            className: "affect-fee__middle",
        }, ...children_2))];
        return react.createElement("li", {
            className: "affect-fee",
        }, ...children_4);
    }
    else {
        return "";
    }
}

export class FrozenMonthsProps extends Record {
    constructor(GlobalDependencies, ContractNr) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
    }
}

export function FrozenMonthsProps$reflection() {
    return record_type("Containers.FrozenMonths.View.FrozenMonthsProps", [], FrozenMonthsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, children_6, inputRecord, LabelText, children_8, inputRecord_1, LabelText_1, children_12, inputRecord_2, children_14, inputRecord_3, LabelText_3, children_18, children_16;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const createFrozenMonthsModalIsOpenState = react.useState(false);
    const frozenMonthsState = react.useState(new LoadState$2(0));
    const isFrozenMonthEnabledState = react.useState(new LoadState$2(0));
    const reasonsState = react.useState(new LoadState$2(0));
    const affectedFeesState = react.useState(new LoadState$2(0));
    const selectedStartDateState = react.useState(DateOnlyExtensions_fromDateTime(now()));
    const selectedEndDateState = react.useState(DateOnlyExtensions_fromDateTime(now()));
    const selectedReasonState = react.useState("");
    const bindingTimeState = react.useState(false);
    const createFrozenMonthSaveState = react.useState(new SaveStatus(0));
    const getMinimumDate = (affectedFees) => defaultArg(fold((acc, fee_1) => {
        let effectiveDate;
        const fee = fee_1;
        const matchValue = [fee.BilledTo, fee.EndDate];
        if (matchValue[0] == null) {
            if (matchValue[1] == null) {
                effectiveDate = fee.InvoicePeriodEnd;
            }
            else {
                const endDateValue = DateOnlyExtensions_fromDateTime(matchValue[1]);
                effectiveDate = ((compare(endDateValue, fee.InvoicePeriodEnd) < 0) ? endDateValue : fee.InvoicePeriodEnd);
            }
        }
        else {
            effectiveDate = matchValue[0];
        }
        if (acc == null) {
            return effectiveDate;
        }
        else {
            return min(compare, acc, effectiveDate);
        }
    }, void 0, affectedFees), DateOnlyExtensions_fromDateTime(now()));
    const minDate = react.useMemo(() => LoadState_map(getMinimumDate, affectedFeesState[0]), [affectedFeesState[0]]);
    const loadFrozenMonths = () => {
        loadEffect(() => loadFrozenMonths_1(props.GlobalDependencies.ClientNr, props.ContractNr), (arg) => {
            frozenMonthsState[1](arg);
        });
    };
    react.useEffect(() => {
        loadFrozenMonths();
        loadEffect(() => loadIsFrozenMonthEnabled_1(props.GlobalDependencies.ClientNr, props.ContractNr), (arg_1) => {
            isFrozenMonthEnabledState[1](arg_1);
        });
        reasonsState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadFrozenMonthReason(props.GlobalDependencies.ClientNr), (_arg) => {
            const result = _arg;
            if (result.tag === 0) {
                const reasons = result.fields[0];
                const patternInput = (!isEmpty(reasons)) ? ((head(reasons) === "") ? (isEmpty(tail(reasons)) ? [singleton_2(["NoReason", getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonthsForm.NoReason")]), ""] : [map((r) => [r, r], reasons), head(reasons)]) : [map((r) => [r, r], reasons), head(reasons)]) : [map((r) => [r, r], reasons), head(reasons)];
                reasonsState[1](new LoadState$2(2, patternInput[0]));
                selectedReasonState[1](patternInput[1]);
                return singleton_1.Zero();
            }
            else {
                reasonsState[1](new LoadState$2(3, result.fields[0]));
                return singleton_1.Zero();
            }
        })));
        affectedFeesState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadAffectedFees_1(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg_1) => {
            const result_1 = _arg_1;
            let arg_3;
            if (result_1.tag === 0) {
                const affectedFees_1 = result_1.fields[0];
                const minDate_1 = getMinimumDate(affectedFees_1);
                selectedStartDateState[1](minDate_1);
                selectedEndDateState[1](addMonths(minDate_1, 1));
                arg_3 = (new LoadState$2(2, affectedFees_1));
            }
            else {
                arg_3 = (new LoadState$2(3, result_1.fields[0]));
            }
            affectedFeesState[1](arg_3);
            return singleton_1.Zero();
        })));
    }, [props.GlobalDependencies, props.ContractNr]);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    let createFrozenMonthButtonHtml;
    const children_2 = [(children = [main(new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateFrozenMonth"), defaultProps.Content, (_arg_4) => {
        createFrozenMonthsModalIsOpenState[1](true);
    }, defaultProps.Disabled, "create-frozenMonths-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("div", {}, ...children))];
    createFrozenMonthButtonHtml = react.createElement("div", {
        className: "frozen_months__buttons",
    }, ...children_2);
    let frozenMonthModalHtml;
    const matchValue_1 = createFrozenMonthsModalIsOpenState[0];
    if (matchValue_1) {
        const matchValue_2 = LoadState_zip3(reasonsState[0], affectedFeesState[0], minDate);
        switch (matchValue_2.tag) {
            case 1: {
                frozenMonthModalHtml = dotsLoading;
                break;
            }
            case 3: {
                frozenMonthModalHtml = error(matchValue_2.fields[0].split(""));
                break;
            }
            case 2: {
                const minDate_2 = matchValue_2.fields[0][2];
                let bodyHtml;
                let monthsStr;
                const monthDiff = DateOnlyExtensions_getAbsoluteMonthDiff(selectedStartDateState[0], selectedEndDateState[0]) | 0;
                const arg_7 = capitalize(getTranslation("Common.Months"));
                monthsStr = toText(printf("%s: %i"))(arg_7)(monthDiff);
                const children_20 = [(children_6 = [inputDate((inputRecord = DateOptions_get_getDefault(), (LabelText = getTranslation("Common.From"), new DateOptions(ofArray([OnChange_1((arg_10) => {
                    const arg_9 = DateOnlyExtensions_fromDateTime(arg_10);
                    selectedStartDateState[1](arg_9);
                }), Value_1(DateOnlyExtensions_toDateTime(selectedStartDateState[0])), Id_5("frozenMonth-modal__frozen-month-from"), FormatDateBy((date_1) => DateTimeExtensions_toDate(locale.ILocale, date_1)), Locale(locale.FlatpickrLocale), MinimumDate(DateOnlyExtensions_toDateTime(minDate_2))]), LabelText, true, inputRecord.Disabled, inputRecord.OnClearClick))))], react.createElement("div", {
                    className: "create-frozen-months__input-container",
                }, ...children_6)), (children_8 = [inputDate((inputRecord_1 = DateOptions_get_getDefault(), (LabelText_1 = getTranslation("Common.To"), new DateOptions(ofArray([OnChange_1((arg_12) => {
                    const arg_11 = DateOnlyExtensions_fromDateTime(arg_12);
                    selectedEndDateState[1](arg_11);
                }), Value_1(DateOnlyExtensions_toDateTime(selectedEndDateState[0])), Id_5("frozenMonth-modal__frozen-month-to"), FormatDateBy((date_4) => DateTimeExtensions_toDate(locale.ILocale, date_4)), Locale(locale.FlatpickrLocale), MinimumDate(DateOnlyExtensions_toDateTime(minDate_2))]), LabelText_1, true, inputRecord_1.Disabled, inputRecord_1.OnClearClick))))], react.createElement("div", {
                    className: "create-frozen-months__input-container",
                }, ...children_8)), (children_12 = [inputCheckbox((inputRecord_2 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_2.Disabled, getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonthsForm.BindingTime"), (e) => {
                    const arg_13 = Browser_Types_Event__Event_get_Checked(e);
                    bindingTimeState[1](arg_13);
                }, bindingTimeState[0], "frozen-months-bindingtime", inputRecord_2.HTMLProps))), react.createElement("div", {
                    className: "create-frozen-months__text-field color-black d-flex flex-column",
                }, monthsStr)], react.createElement("div", {
                    className: "create-frozen-months__input-container",
                }, ...children_12)), (children_14 = [selectOption((inputRecord_3 = SelectOption_get_getDefault(), (LabelText_3 = getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonthsForm.Reason"), new SelectOption(new ValueProp(0, selectedReasonState[0], (e_1) => {
                    const arg_14 = Browser_Types_Event__Event_get_Value(e_1);
                    selectedReasonState[1](arg_14);
                }), "frozen-months-reason", matchValue_2.fields[0][0], inputRecord_3.Classes, LabelText_3, inputRecord_3.Disabled, inputRecord_3.HTMLProps))))], react.createElement("div", {
                    className: "create-frozen-months__input-container",
                }, ...children_14)), (children_18 = [(children_16 = map((impactfee) => renderImpactFee(getTranslation, impactfee, selectedStartDateState[0], selectedEndDateState[0]), matchValue_2.fields[0][1]), react.createElement("ol", {
                    className: "create-frozen-months__affect-fee-list",
                }, ...children_16))], react.createElement("div", {}, ...children_18))];
                bodyHtml = react.createElement("div", {
                    className: "create-frozen-months",
                }, ...children_20);
                const cancelButtonProps = new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateFrozenMonths.Cancel"), defaultProps.Content, (_arg_5) => {
                    createFrozenMonthsModalIsOpenState[1](false);
                }, defaultProps.Disabled, "create-frozen-months-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
                const acceptButtonProps = new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.CreateFrozenMonths.Create"), defaultProps.Content, (_arg_6) => {
                    const dto = new CreateFrozenMonthsDTO(DateOnlyExtensions_yyyy_MM_dd(selectedStartDateState[0]), DateOnlyExtensions_yyyy_MM_dd(selectedEndDateState[0]), strToOpt(selectedReasonState[0]), bindingTimeState[0]);
                    createFrozenMonthSaveState[1](new SaveStatus(1));
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(createFrozenMonths(props.GlobalDependencies.ClientNr, props.ContractNr, dto), (_arg_3) => {
                        const result_2 = _arg_3;
                        const arg_5 = (result_2.tag === 0) ? (new SaveStatus(2)) : (new SaveStatus(3, result_2.fields[0]));
                        createFrozenMonthSaveState[1](arg_5);
                        return singleton_1.Zero();
                    })));
                }, defaultProps.Disabled, "create-frozen-months-modal-accept-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
                frozenMonthModalHtml = renderAsModalThenSaveState(true, new ModalSize(1), getTranslation("CustomerContract.Invoicee.Subscriptions.CreateFrozenMonths"), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Close"), (_arg_7) => {
                    loadFrozenMonths();
                    createFrozenMonthsModalIsOpenState[1](false);
                    createFrozenMonthSaveState[1](new SaveStatus(0));
                }, singleton_2([getTranslation("Common.Saving"), createFrozenMonthSaveState[0]]));
                break;
            }
            default: {
                frozenMonthModalHtml = react.createElement(react.Fragment, {});
            }
        }
    }
    else {
        frozenMonthModalHtml = react.createElement(react.Fragment, {});
    }
    const children_47 = toList(delay(() => {
        let children_26, children_43, children_33, children_41, children_39, children_37, children_45, children_22;
        const matchValue_3 = frozenMonthsState[0];
        switch (matchValue_3.tag) {
            case 1: {
                return singleton(react.createElement("div", {
                    id: "render-frozenMonths-loading",
                }, dotsLoading));
            }
            case 3: {
                return singleton((children_26 = [error(matchValue_3.fields[0].split(""))], react.createElement("div", {
                    id: "render-frozenMonths-error",
                }, ...children_26)));
            }
            case 2: {
                let frozenMonthsHtml;
                const _arg_8 = matchValue_3.fields[0];
                if (isEmpty(_arg_8)) {
                    const children_28 = [info(getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonthsMissing").split(""))];
                    frozenMonthsHtml = react.createElement("span", {
                        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.FrozenMonthsMissing",
                    }, ...children_28);
                }
                else {
                    frozenMonthsHtml = renderFrozenMonthsTable(getTranslation, locale, _arg_8);
                }
                const matchValue_4 = isFrozenMonthEnabledState[0];
                switch (matchValue_4.tag) {
                    case 1: {
                        return singleton(dotsLoading);
                    }
                    case 3: {
                        return singleton(error(matchValue_4.fields[0].split("")));
                    }
                    case 2: {
                        return matchValue_4.fields[0] ? singleton((children_43 = [(children_33 = [react.createElement("div", {
                            className: "d-flex create-frozen_months-button col-sm-auto mb-3",
                        }, createFrozenMonthButtonHtml)], react.createElement("div", {
                            className: "row",
                        }, ...children_33)), (children_41 = [(children_39 = [(children_37 = [react.createElement("div", {
                            className: "mb-3",
                        }, frozenMonthsHtml)], react.createElement("div", {}, ...children_37))], react.createElement("div", {
                            className: "frozen_months__container col-sm-auto",
                        }, ...children_39))], react.createElement("div", {
                            className: "row",
                        }, ...children_41)), frozenMonthModalHtml], react.createElement("div", {
                            className: "frozenMonths",
                        }, ...children_43))) : singleton((children_45 = [info(getTranslation("CustomerContract.Invoicee.Subscriptions.SubproductFreeMonthFeeMissing").split(""))], react.createElement("div", {
                            className: "mb-3",
                            id: "frozenMonths-model-error",
                        }, ...children_45)));
                    }
                    default: {
                        return singleton(react.createElement(react.Fragment, {}));
                    }
                }
            }
            default: {
                return singleton((children_22 = [info(getTranslation("CustomerContract.Invoicee.Subscriptions.WaitingToLoadfrozenMonths").split(""))], react.createElement("div", {
                    id: "render-frozenMonths-waiting",
                    ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.WaitingToLoadfrozenMonths",
                }, ...children_22)));
            }
        }
    }));
    return react.createElement("div", {
        id: "frozen-months",
    }, ...children_47);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FrozenMonths\\View.fs", 391);

